var lib_core = require("lib-core");
var FootprintSettingsStateMachine        = require("./../../../shared/settings/footprintSettingsStateMachine.js");

var PackageSettingsStateMachine = function (root, model) {
    FootprintSettingsStateMachine.apply(this, arguments);
};

lib_core.inherit(PackageSettingsStateMachine, FootprintSettingsStateMachine);

module.exports = PackageSettingsStateMachine;
